import {
  CoreFlightsRebookComponent,
  type RebookConfirmationPageProps,
  useFlightsRebookStyles,
} from "@b2bportal/core-flights-rebook";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Page } from "@b2bportal/core-ui";
import clsx from "clsx";
import { BookingConfirmation } from "../../../modules/flight-checkout/components/BookingConfirmation";
import defaultStyles from "./RebookConfirmationPage.module.scss";

const COMPONENT_KEY = CoreFlightsRebookComponent.RebookConfirmationPage;

export const RebookConfirmationPage = ({
  className,
  rebookedFlight,
}: RebookConfirmationPageProps) => {
  const styles = useFlightsRebookStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  if (rebookedFlight == null) {
    return null;
  }

  return (
    <Page className={clsx(block, className)} footer={<></>}>
      <BookingConfirmation />
    </Page>
  );
};

export default RebookConfirmationPage;
